import { render, staticRenderFns } from "./SLRPerson3.vue?vue&type=template&id=72341599"
import script from "./SLRPerson3.vue?vue&type=script&lang=js"
export * from "./SLRPerson3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports